import { Client } from './../dto/client/client';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';


@Injectable({ providedIn: 'root' })
export class ClientService {
  constructor(private http: HttpClient) {

  }

  get(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/client').pipe(map(data => data));
  }

  getAdmin(pageSize: number, pageIndex: number, dataFilter: Client, sortCol: string, sortDir: string): Observable<any> {

    let params = new HttpParams().append('page', pageIndex.toString()).append('size', pageSize.toString())
      .append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString());
    if (dataFilter) {
      Object.keys(dataFilter).forEach(item => {
        params = params.append(item.toString(), dataFilter[item]?.toString() || '')
      })
    }

    return this.http.get(environment.apiUrl + '/dashboard/admin/client', { params: params }).pipe(map(data => data));
  }

  modify(client: any): Observable<any> {
    return this.http.post(environment.apiUrl + '/dashboard/admin/client', client, {
    }).pipe(val => val);
  }

  getByName(nameClient: string): Observable<any> {
    let params = new HttpParams().append('name', nameClient)
    return this.http.get(environment.apiUrl + '/dashboard/admin/client').pipe(val => val);
  }

  getById(id: string): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/admin/client/' + id).pipe(map(data => data));
  }

  deleteById(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + '/dashboard/admin/client/' + id).pipe(map(data => data));
  }

  uploadClientsCsv(csv_file: File): Observable<any> {
    const formData = new FormData();
    formData.append("csv_file", csv_file, csv_file.name);
    return this.http.post(environment.apiUrl + '/dashboard/admin/addClientsCsv', formData).pipe(val => val);
  }


  downloadTemplate() {
    var headers = new Headers();
    headers.append('responseType', 'blob');
    return this.http.get(environment.apiUrl + '/dashboard/admin/getCsvTemplate', {
      responseType: 'blob'
    })
      .pipe(map(res => res));
  }
  downloadResponseFile(){
    var headers = new Headers();
    headers.append('responseType', 'blob');
    return this.http.get(environment.apiUrl + '/dashboard/admin/getClientCsv', {
      responseType: 'blob'
    })
      .pipe(map(res => res));
  }
}

